import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sd-workbook-fill",
  "use": "sd-workbook-fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"sd-workbook-fill\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 1a3 3 0 00-3 3v16a3 3 0 003 3h12a3 3 0 003-3V4a3 3 0 00-3-3H6zm2 1H7v20h1V2zm9 10V2h-5v10l2.5-2 2.5 2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol